import { Link } from 'react-router-dom'

const variants = {
  primary:
    'bg-primary text-white hover:bg-primary/90 shadow-lg shadow-primary/25 hover:shadow-primary/40',
  secondary:
    'bg-secondary text-white hover:bg-secondary/90 shadow-lg shadow-secondary/25',
  accent:
    'bg-accent-strong text-white hover:bg-accent-strong/90 shadow-lg shadow-accent-strong/30 hover:shadow-accent-strong/50',
  outline:
    'border-2 border-white text-white hover:bg-white hover:text-primary backdrop-blur-sm',
  outlineDark:
    'border-2 border-primary text-primary hover:bg-primary hover:text-white',
  ghost: 'text-primary hover:bg-primary/5',
}

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-sm',
  lg: 'px-8 py-4 text-base',
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  type = 'button',
  ...props
}) {
  const baseClasses = `inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`

  if (to) {
    return (
      <Link to={to} className={baseClasses} {...props}>
        {children}
      </Link>
    )
  }

  if (href) {
    return (
      <a href={href} className={baseClasses} {...props}>
        {children}
      </a>
    )
  }

  return (
    <button type={type} className={baseClasses} {...props}>
      {children}
    </button>
  )
}
